import { del, get, post, put } from "helpers/api_helper/Authentication/authenticationApiHelper"
import * as url from "helpers/url_helper/url_helper"


export const getRoleDefinitions = () => get(url.ROLE_DEFINITIONS)
export const addNewRoleDefinition = roleDefinition => post(url.ROLE_INSERT, roleDefinition)
export const updateRoleDefinition = roleDefinition => put(url.ROLE_UPDATE, roleDefinition)
export const deleteRoleDefinition = guid => del(url.ROLE_DELETE, { params: { guid } })
export const getPageOperationListForRoleDefinition = () => get(url.PAGE_OPERATION)
export const getPageOperationForValueList = guid => get(url.PAGE_OPERATION_FOR_VALUE,{ params: { guid } })